import React, { Component } from 'react';
import { Button, Radio, DatePicker, Space, Table, message, Modal } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import DepositApi from '../../../functions/api/booking/DepositApi';
import { getDepositColumns } from './columns';
import ButtonFormatter from './ButtonFormatter';
import CaptureModal from './CaptureModal';
import EditDepositModal from './EditDepositModal';
import ViewDepositModal from './ViewDepositModal';
import moment from 'moment';

const { RangePicker } = DatePicker;

class ListDeposit extends Component {
  _isMounted = false; // ✅ FLAG

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: false,
      filterType: 'deposit_date',
      dateRange: [moment().subtract(90, 'days'), moment()],
      selected: null,
      showCapture: false,
      showEdit: false,
      showView: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchDeposits();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  fetchDeposits = async () => {
    if (!this._isMounted) return;

    this.setState({ loading: true });

    try {
      const res = await DepositApi.getPagination(1, 1000);
      let data = Array.isArray(res) ? res : res?.data || [];

      const { filterType, dateRange } = this.state;

      if (dateRange?.length === 2) {
        const [start, end] = dateRange;
        const startTime = new Date(start).getTime();
        const endTime = new Date(end).getTime();

        data = data.filter((item) => {
          const t = item[filterType];
          if (!t) return false;

          const itemTime = new Date(t).getTime();
          return itemTime >= startTime && itemTime <= endTime;
        });
      }

      if (this._isMounted) {
        this.setState({ data });
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    }
  };
  /** ✅ THU TIỀN */
  handleCapture = (rec) => {
    this.setState({
      selected: rec,
      showCapture: true,
    });
  };

  /** ✅ HOÀN TIỀN ALL → VOIDED */
  handleRefund = (rec) => {
    Modal.confirm({
      title: 'Xác nhận hoàn tiền toàn bộ?',
      content: `Hoàn toàn bộ tiền cho mã đặt cọc: ${rec.id}`,
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk: async () => {
        const rs = await DepositApi.releaseAuthorization(rec.id);
        if (String(rs?.status || '').startsWith('2')) {
          message.success('✅ Hoàn tiền thành công');
          this.fetchDeposits();
        } else {
          message.error('❌ Hoàn tiền thất bại');
        }
      },
    });
  };

  /** ✅ XEM CHI TIẾT */
  handleView = async (rec) => {
    const detail = await DepositApi.getById(rec.id);
    console.log('Viewing deposit detail:', detail);
    if (!detail) return message.error('Không tìm thấy dữ liệu');

    this.setState({
      selected: detail,
      showView: true,
    });
  };

  /** ✅ SỬA THÔNG TIN */
  handleEdit = async (rec) => {
    const detail = await DepositApi.getById(rec.id);
    if (!detail) return message.error('Không tìm thấy dữ liệu');

    this.setState({
      selected: detail,
      showEdit: true,
    });
  };
  /** ✅ XÓA */
  handleDelete = async (rec) => {
    const rs = await DepositApi.deleteDeposit(rec.id);
    if (rec.id === rs?.id) {
      message.success('✅ Xóa thành công');
      this.fetchDeposits();
    } else {
      message.error('❌ Xóa thất bại');
    }
  };

  render() {
    const {
      data,
      loading,
      filterType,
      dateRange,
      showCapture,
      showEdit,
      showView,
      selected,
    } = this.state;

    const columns = getDepositColumns((record) => (
      <ButtonFormatter
        record={record}
        onCapture={this.handleCapture}
        onRefund={this.handleRefund}
        onView={this.handleView}
        onEdit={this.handleEdit}
        onDelete={this.handleDelete}
      />
    ));

    return (
      <div>
        <Space
          style={{
            marginBottom: 16,
          }}
        >
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={this.fetchDeposits}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            Làm mới
          </Button>

          <Radio.Group
            value={filterType}
            onChange={(e) =>
              this.setState({ filterType: e.target.value }, this.fetchDeposits)
            }
          >
            <Radio value="deposit_date">Ngày đặt cọc</Radio>
            <Radio value="refund_date">Ngày hoàn tiền</Radio>
          </Radio.Group>

          <RangePicker
            value={dateRange}
            onChange={(d) =>
              this.setState({ dateRange: d }, this.fetchDeposits)
            }
            format="DD/MM/YYYY"
          />
        </Space>

        <Table
          rowKey="id"
          bordered
          loading={loading}
          dataSource={data}
          columns={columns}
          pagination={false}
          scroll={{ x: 2000 }}
        />

        {/* Thu tiền */}
        <CaptureModal
          open={showCapture}
          deposit={selected}
          onClose={() => this.setState({ showCapture: false, selected: null })}
          refresh={this.fetchDeposits}
        />

        {/* Sửa thông tin */}
        <EditDepositModal
          open={showEdit}
          deposit={selected}
          onClose={() => this.setState({ showEdit: false, selected: null })}
          refresh={this.fetchDeposits}
        />

        {/* Xem thông tin (read-only) */}
        <ViewDepositModal
          open={showView}
          deposit={selected}
          onClose={() => this.setState({ showView: false, selected: null })}
        />
      </div>
    );
  }
}

export default ListDeposit;
